<template>
	<div v-if='lease'>

		<div class='grid'>

			<template>
				<custom-p-checkbox v-model='checkedLegendList' multiple :multiple-value='1' label='Номер квартала' :disabled='!actLpoIsDraft'/>
				<div class='text-legend-item area-num-legend'>{{ firstLpo.area }}</div>
			</template>

			<template>
				<custom-p-checkbox v-model='checkedLegendList' multiple :multiple-value='2' label='Номер выдела' :disabled='!actLpoIsDraft'/>
				<div class='text-legend-item section-num-legend'>{{ firstLpo.section }}</div>
			</template>

			<template>
				<custom-p-checkbox v-model='checkedLegendList' multiple :multiple-value='3' label='Номер лп выдела' :disabled='!actLpoIsDraft'/>
				<div class='text-legend-item section-num-legend'>{{ firstLpo.section + '(' + (firstLpo.section_lp ? firstLpo.section_lp : '1') + ')' }}</div>
			</template>

			<template>
				<custom-p-checkbox v-model='checkedLegendList' multiple :multiple-value='4' label='Границы участка' :disabled='!actLpoIsDraft'/>
				<img src='@/assets/files/legend/lpo_border.png'>
			</template>

			<template>
				<custom-p-checkbox v-model='checkedLegendList' multiple :multiple-value='5' label='Границы лесопатологических выделов' :disabled='!actLpoIsDraft'/>
				<img src='@/assets/files/legend/lp_section_border.png'>
			</template>

			<template>
				<custom-p-checkbox v-model='checkedLegendList' multiple :multiple-value='6' label='Характерные точки по границам лп выделов' :disabled='!actLpoIsDraft'/>
				<div class='text-legend-item char-points-legend'>1</div>
			</template>

			<template v-if='currentLpo.inspection_type_id === "1"'>
				<custom-p-checkbox v-model='checkedLegendList' multiple :multiple-value='7' label='Ленты перечета' :disabled='!actLpoIsDraft'/>
				<img src='@/assets/files/legend/lp.png'>
			</template>

			<template v-if='currentLpo.inspection_type_id === "4"'>
				<custom-p-checkbox v-model='checkedLegendList' multiple :multiple-value='8' label='Круговые площадки' :disabled='!actLpoIsDraft'/>
				<img src='@/assets/files/legend/kpp.png'>
			</template>

			<template v-if='currentLpo.inspection_type_id === "2"'>
				<custom-p-checkbox v-model='checkedLegendList' multiple :multiple-value='9' label='Реласкопические площадки' :disabled='!actLpoIsDraft'/>
				<img src='@/assets/files/legend/rlpp.png'>
			</template>
<!-- 
			<template v-if='currentLpo.inspection_type_id === "6"'>
				<custom-p-checkbox v-model='checkedLegendList' multiple :multiple-value='10' label='Аварийные деревья'/>
				<img src='@/assets/files/legend/av.png'>
			</template> -->
			

		</div>


		<div v-if='!listsAreMatch' class='btn-block'>
			<div>
				<p-button @click='reset' label='Отменить' class='p-button-secondary' icon='fa fa-times'/>
				<p-button @click='save' label='Сохранить' class='p-button-success' icon='fa fa-check'/>
			</div>
		</div>
		<!-- {{ checkedLegendList }} -->

	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';

	export default {
		name: 'LeaseDataLegendModal',

		model: {
			prop: 'isOpen',
			event: 'toggle'
		},

		props: {
			isOpen: {
				type: Boolean,
				default: false
			}
		},

		data: () => ({
			checkedLegendList: []
		}),

		computed: {
			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },

			listLength() {
				return this.checkedLegendList.length;
			},

			firstLpo() {
				return this.actLpoList.length ? this.actLpoList[0] : null
			},

			...mapState('lpoData', {
				currentLpo: state => state.currentLpo,
				actLpoList: state => state.actLpoList
			}),

			...mapState('actLpo', {
				lease: state => state.lease.lease
			}),

			savedLegendList() {
				return this.lease.sketch_legend_ids
					?	this.lease.sketch_legend_ids
						.slice(1, this.lease.sketch_legend_ids.length - 1)
						.split(',')
						.map(item => +item)
					: [];
			},

			listsAreMatch() {
				if (this.checkedLegendList.length !== this.savedLegendList.length) {
					return false;
				}

				for (let i = 0; i < this.checkedLegendList.length; ++i) {
					if (this.checkedLegendList[i] !== this.savedLegendList[i]) {
						return false;
					}
				}

				return true;
			}
		},

		watch: {
			listLength(listLength) {
				this.checkedLegendList.sort();
			}
		},

		methods: {
			onModalToggle(event) {
				this.$emit('toggle', event);
			},

			save() {
				this.saveLegend(this.checkedLegendList).then(res => {
					return this.getLease().then(res => {
						// this.reset();
					});
				});
			},

			reset() {
				this.checkedLegendList = this.savedLegendList.slice();
			},

			test() {
				console.log(this.lease.sketch_legend_ids);
				console.log(this.savedLegendList);
			},

			...mapActions('actLpo', [
				'saveLegend',
				'getLease'
			])
		},

		created() {
			this.getLease();
			this.reset();
		}

	};
</script>

<style scoped>
	.grid {
		display: grid;
		grid-template-columns: auto auto;
		grid-column-gap: 1.5rem;
		grid-row-gap: 0.7rem;
		align-items: center;

		margin-bottom: 2rem;
	}

	.text-legend-item {
		font-family: 'Times New Roman';
		font-weight: bold;
	}

	.area-num-legend {
		font-size: 24px;
	}

	.section-num-legend {
		font-size: 17px;
	}

	.char-points-legend {
		font-size: 14px;
	}

	.btn-block {
		display: flex;
		justify-content: flex-end;
	}



	.btn-block > div .p-button:first-child {
		margin-right: 0.5rem;
	}
</style>